import { BadgeCheck } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface VerifiedBadgeProps {
  tier?: 'basic' | 'pro' | 'premium';
  size?: 'sm' | 'md' | 'lg';
  showTooltip?: boolean;
  className?: string;
}

const tierColors = {
  basic: 'text-blue-500 fill-blue-500/20',
  pro: 'text-purple-500 fill-purple-500/20',
  premium: 'text-amber-500 fill-amber-500/20',
};

const tierLabels = {
  basic: 'Verified Tool',
  pro: 'Pro Verified',
  premium: 'Premium Verified',
};

const sizeClasses = {
  sm: 'h-3.5 w-3.5',
  md: 'h-4 w-4',
  lg: 'h-5 w-5',
};

export function VerifiedBadge({ 
  tier = 'basic', 
  size = 'md', 
  showTooltip = true,
  className 
}: VerifiedBadgeProps) {
  const badge = (
    <BadgeCheck 
      className={cn(
        sizeClasses[size],
        tierColors[tier],
        'flex-shrink-0',
        className
      )} 
    />
  );

  if (!showTooltip) return badge;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {badge}
        </TooltipTrigger>
        <TooltipContent>
          <p className="text-xs">{tierLabels[tier]}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
